import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-credit-collection',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
  templateUrl: './credit-collection.component.html',
})
export class CreditCollectionComponent implements OnInit, OnChanges, OnDestroy {
  @Input() compact = false;
  @Input() consolidated = false;
  @Input() refreshKey: any;
  company: any;
  loading = false;
  error = '';
  summary: any[] = [];
  items: any[] = [];
  search = '';
  companyFilter = '';
  page = 1;
  readonly pageSize = 50;
  private subscriptions = new Subscription();
  private request = 0;
  private ready = false;

  constructor(private http: HttpService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    if (!this.compact) this.consolidated = this.route.snapshot.queryParams.scope === 'consolidated';
    this.ready = true;
    this.subscriptions.add(this.http.getSelectedCompany().subscribe(company => {
      this.company = company;
      this.companyFilter = '';
      if (company) void this.load();
    }));
  }

  ngOnChanges(): void { if (this.ready && this.company && !this.refreshKey) void this.load(); }
  ngOnDestroy(): void { this.request++; this.subscriptions.unsubscribe(); }

  async load(): Promise<void> {
    const request = ++this.request;
    this.loading = true;
    this.error = '';
    this.items = [];
    this.summary = [];
    try {
      const response: any = await this.http.post('/admin/player-credit/collection', {
        consolidated: this.consolidated, details: !this.compact,
      });
      if (request !== this.request) return;
      if (!response?.status) throw new Error(response?.message || 'Unable to load credit collections.');
      this.items = response.items || [];
      this.summary = response.summary || [];
      this.page = 1;
    } catch (error: any) {
      if (request === this.request) this.error = error.message || 'Unable to load credit collections.';
    } finally {
      if (request === this.request) this.loading = false;
    }
  }

  get companies(): any[] {
    return [...new Map(this.items.map(item => [item.company_uuid, { uuid: item.company_uuid, name: item.company_name }])).values()];
  }
  get filtered(): any[] {
    const search = this.search.trim().toLowerCase();
    return this.items.filter(item => (!this.companyFilter || item.company_uuid === this.companyFilter) &&
      (!search || [item.player_code, item.player_name, item.mobile].some(value => String(value || '').toLowerCase().includes(search))));
  }
  get visible(): any[] { return this.filtered.slice((this.page - 1) * this.pageSize, this.page * this.pageSize); }
}
